module.exports = __webpack_public_path__ + "static/media/grinning-face-with-smiling-eyes-svgrepo-com.54926f33.svg";